import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

/* Defining the animation. */
export const sidenavAnimation = trigger('openClose', [
  state('false', style({ 'max-width': '*', 'min-width': '*' })),
  state('true', style({ 'max-width': '301px', 'min-width': '301px' })),
  transition('false <=> true', [animate('0.08s ease-in-out')]),
]);
